import React from "react";
import { STATE_PILL_CLASS, STATE_SHORT, STATE_ICON } from "@/lib/agendaStates";

/**
 * Pill compatta per stato evento. Mostra simbolo Lucide + sigla 2-3 lettere.
 * Riusabile in dashboard, agenda, schede cliente.
 */
export default function StateBadge({ state, withIcon = true, className = "", testid }) {
  const cls = STATE_PILL_CLASS[state] || "bg-neutral-100 text-neutral-700";
  const Icon = STATE_ICON[state];
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9.5px] font-bold uppercase tracking-[0.12em] leading-none ${cls} ${className}`}
      data-testid={testid || `state-badge-${state}`}
    >
      {withIcon && Icon ? <Icon className="w-2.5 h-2.5" strokeWidth={2.2} /> : null}
      {STATE_SHORT[state] || state}
    </span>
  );
}
